import React from 'react';
import clsx from 'clsx';

import Button from '@components/_shared/button';
import { SocialButton } from '@components/authorization/socialButton';
import { BaseComponentProps } from '@utils/types/baseComponents';
import { Mail } from '@assets/icons';

import styles from './styles.module.scss';

type Props = {
  onGoogleSignUpClick?: () => void;
  onSignUpWithEmailClick?: () => void;
} & BaseComponentProps;

/** Sign up social auth buttons */
export function SignUpButtons(props: Props) {
  const { containerStyle, onGoogleSignUpClick, onSignUpWithEmailClick } = props;

  return (
    <div className={clsx([styles.container, containerStyle])}>
      {onGoogleSignUpClick && (
        <SocialButton socialType="google" onClick={onGoogleSignUpClick} />
      )}

      <span className={styles.word}>or</span>

      {onSignUpWithEmailClick && (
        <Button
          onClick={onSignUpWithEmailClick}
          containerStyle={styles.signUpButton}
          variant="blueContained"
        >
          <div className={styles.buttonLabel}>
            <Mail className={styles.mailIcon} />
            Sign Up With Email
          </div>
        </Button>
      )}
    </div>
  );
}
